import { render, staticRenderFns } from "./CardapioPizzaConfig.vue?vue&type=template&id=9204a1ee&scoped=true"
import script from "./CardapioPizzaConfig.vue?vue&type=script&lang=js"
export * from "./CardapioPizzaConfig.vue?vue&type=script&lang=js"
import style0 from "./CardapioPizzaConfig.vue?vue&type=style&index=0&id=9204a1ee&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9204a1ee",
  null
  
)

export default component.exports